import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError, of } from 'rxjs';
import { articleCards } from 'constants/routes';


/**
 * Fetches article cards based on the provided payload.
 *
 * @param {Object} payload - The payload containing the blogArticlesSearchCommand data.
 * @returns {Observable<string | Error>} An observable that emits the response as text or an error.
 *
 * The function sends a POST request with the given payload to fetch article cards.
 * It processes the response to return it as text and handles any errors by emitting them as observable values.
 */
const getArticleCards$ = (payload) => {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      blogArticlesSearchCommand: payload
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };

  return fromFetch(articleCards, requestObject).pipe(
    // Process the response and convert it to text
    switchMap((response) => response.text()),
    // Handle errors and emit them as observable values
    catchError((error) => of(error))
  );
};

export default getArticleCards$;